import stahltreppe_1 from './stahltreppe_1.jpg';
import stahltreppe_2 from './stahltreppe_2.jpg';


export const portfolio_stahltreppe = [
    {product_img: stahltreppe_1},
    {product_img: stahltreppe_2}
]